import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";

export const LOGIN_ADMIN = 'LOGIN_ADMIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SEND_OTP = 'SEND_OTP';
export const MASTER_DASHBOARD = 'MASTER_DASHBOARD';
export const ALL_APPOINTMENT_COUNT = 'ALL_APPOINTMENT_COUNT';
export const DOCTOR_APPOINTMENT_COUNT = 'DOCTOR_APPOINTMENT_COUNT';
export const GET_USER_DATA = 'GET_USER_DATA';
export const ADD_OTP = 'ADD_OTP';
export const GET_OTP = 'GET_OTP';
export const UPDATE_OTP = 'UPDATE_OTP';
export const DELETE_OTP = 'DELETE_OTP';
export const ADD_REFERRAL = 'ADD_REFERRAL';
export const GET_REFERRAL = 'GET_REFERRAL';
export const UPDATE_REFERRAL = 'UPDATE_REFERRAL';
export const DELETE_REFERRAL = 'DELETE_REFERRAL';

const adminLoginAction = (payload) => ({ type: LOGIN_ADMIN, payload: payload });
const loginAction = (payload) => ({ type: LOGIN_SUCCESS });
const logoutAction = (payload) => ({ type: LOGOUT_SUCCESS });
const sendOtpAction = (payload) => ({ type: SEND_OTP, payload: payload });
const masterDashboardAction = (payload) => ({ type: MASTER_DASHBOARD, payload: payload });
const allAppointmentCountAction = (payload) => ({ type: ALL_APPOINTMENT_COUNT, payload: payload });
const doctorAppointmentCountAction = (payload) => ({ type: DOCTOR_APPOINTMENT_COUNT, payload: payload });
const getUserDataAction = (payload) => ({ type: GET_USER_DATA, payload: payload });
const addOtpDataAction = (payload) => ({ type: ADD_OTP, payload: payload });
const getOtpDataAction = (payload) => ({ type: GET_OTP, payload: payload });
const updateOtpDataAction = (payload) => ({ type: UPDATE_OTP, payload: payload });
const deleteOtpDataAction = (payload) => ({ type: DELETE_OTP, payload: payload });
const addReferralDataAction = (payload) => ({ type: ADD_REFERRAL, payload: payload });
const getReferralDataAction = (payload) => ({ type: GET_REFERRAL, payload: payload });
const updateReferralDataAction = (payload) => ({ type: UPDATE_REFERRAL, payload: payload });
const deleteReferralDataAction = (payload) => ({ type: DELETE_REFERRAL, payload: payload });

export const adminLogin = (payload) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`${BASEURL}/auth/login`, payload);

            localStorage.setItem('isAuthenticated', 'true');
            localStorage.setItem('lastLoginTime', Date.now().toString());
            localStorage.setItem('type', res?.data?.user?.type);
            localStorage.setItem('token', res?.data?.user?.token);
            localStorage.setItem('logo', res?.data?.logo);

            dispatch(adminLoginAction(res));

            return res; // 👈 return the response so .then(res) gets it
        } catch (error) {
            const errResponse = error?.response;
            dispatch(adminLoginAction(errResponse));
            return errResponse; // 👈 return error for .then(res) or .catch()
        }
    };
};

export const loginSuccess = () => {
    return {
        type: 'LOGIN_SUCCESS',
    };
}

export const logoutSuccess = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('token');
    localStorage.removeItem('type');
    return {
        type: 'LOGOUT_SUCCESS',
    };
}

export const sendOtp = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/auth/verify-otp`, payload).then(((res) => {
                localStorage.setItem('isAuthenticated', 'true');
                localStorage.setItem('lastLoginTime', Date.now().toString());
                localStorage.setItem('type', res?.data?.user?.type)
                localStorage.setItem('token', res?.data?.user?.token)
                toast.success('Login successfully')
                dispatch(sendOtpAction(res));
                dispatch(loginAction());
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(sendOtpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const masterDashboard = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem("token");
            await axios.get(`${BASEURL}/master/DashboardCount`, {
                headers: { Authorization: `Bearer ${token}` },
            }).then(((res) => {
                dispatch(masterDashboardAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(masterDashboardAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const appointmentAllCount = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/appointment/countAllAppointments`).then(((res) => {
                dispatch(allAppointmentCountAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(allAppointmentCountAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const doctorAppointmentAllCount = (currentDate) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`${BASEURL}/appointment/doctorWiseCounts?date=${currentDate}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(doctorAppointmentCountAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(doctorAppointmentCountAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getUserData = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/auth/getAuthData`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(getUserDataAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getUserDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addOtpData = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/auth/setOtp`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(addOtpDataAction(res));
                dispatch(getOtpData())
                toast.success('Code Add Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addOtpDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getOtpData = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/auth/getOtp`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(getOtpDataAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getOtpDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateOtpData = (payload, id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/auth/updateOtp/${id}`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(updateOtpDataAction(res));
                dispatch(getOtpData())
                toast.success('Code Update Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong!')
                dispatch(updateOtpDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteOtpData = (id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.delete(`${BASEURL}/auth/deleteOtp/${id}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(deleteOtpDataAction(res));
                dispatch(getOtpData())
                toast.success('Code Delete Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong!')

                dispatch(deleteOtpDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addReferral = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/createRefferralConfig`, payload).then(((res) => {
                dispatch(addReferralDataAction(res));
                dispatch(getReferral())
                toast.success('Code Add Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addReferralDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getReferral = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getRefferralConfig`).then(((res) => {
                dispatch(getReferralDataAction(res));
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(getReferralDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateReferral = (id, payload) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateRefferralConfig/${id}`, payload).then(((res) => {
                dispatch(updateReferralDataAction(res));
                dispatch(getReferral())
                toast.success('Code Update Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateReferralDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteReferral = (id) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteRefferralConfig/${id}`).then(((res) => {
                dispatch(deleteReferralDataAction(res));
                dispatch(getReferral())
                toast.success('Code Delete Successfully!')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteReferralDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}
